<template>
  <div>
    <v-row dense class="mb-4">
      <v-col cols="12" sm="2" md="2">
        <v-text-field v-model.number="value.mana" label="Mana:" hide-details/>
      </v-col>
      <v-col cols="12" sm="2" md="2">
        <v-text-field v-model.number="value.points" label="Points:" hide-details/>
      </v-col>
      <v-col cols="12" sm="2" md="2">
        <v-select
            v-model="value.shape"
            :items="shapeTypes"
            item-text="name"
            item-value="id"
            label="Shape type:"
            hide-details
        />
      </v-col>
      <v-col cols="12" sm="3" md="3">
        <r-item-container-mode :model.sync="value.container"/>
      </v-col>
      <v-col cols="12" sm="3" md="3">
        <r-item-collect-mode :model.sync="value.collect"/>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="4" md="4">
        <v-btn v-if="!!value.rewardOnMerge" @click="onRewardOnMerge" small color="success"
               class="my-1 fill-width">Merged on Merge
        </v-btn>
        <v-btn v-else @click="onRewardOnMerge" small outlined color="primary" class="my-1 fill-width">
          Merged on Merge
        </v-btn>

        <v-btn v-if="!!value.rewardOnCreate" @click="onRewardOnCreate" small color="success"
               class="my-1 fill-width">Reward On Create
        </v-btn>
        <v-btn v-else @click="onRewardOnCreate" small outlined color="primary" class="my-1 fill-width">
          Reward On Create
        </v-btn>

        <v-btn v-if="!!value.rewardOnRemove" @click="onRewardOnRemove" small color="success"
               class="my-1 fill-width">Reward On Remove
        </v-btn>
        <v-btn v-else @click="onRewardOnRemove" small outlined color="primary" class="my-1 fill-width">
          Reward On Remove
        </v-btn>

        <v-btn v-if="!!value.rewardOnDelete" @click="onRewardOnDelete" small color="success"
               class="my-1 fill-width">Reward On Delete
        </v-btn>
        <v-btn v-else @click="onRewardOnDelete" small outlined color="primary" class="my-1 fill-width">
          Reward On Delete
        </v-btn>

        <v-btn v-if="!!value.rewardOnLevelUp" @click="onRewardOnLevelUp" small color="success"
               class="my-1 fill-width">Reward On LevelUp
        </v-btn>
        <v-btn v-else @click="onRewardOnLevelUp" small outlined color="primary" class="my-1 fill-width">
          Reward On LevelUp
        </v-btn>

      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-btn v-if="!!value.workerConfig" @click="onWorkerConfig" small color="success"
               class="my-1 fill-width">Worker Config
        </v-btn>
        <v-btn v-else @click="onWorkerConfig" small outlined color="primary" class="my-1 fill-width">Worker
          Config
        </v-btn>
        <v-btn v-if="!!value.searchConfig" @click="onSearchConfig" small color="success"
               class="my-1 fill-width">Search Config
        </v-btn>
        <v-btn v-else @click="onSearchConfig" small outlined color="primary" class="my-1 fill-width">Search
          Config
        </v-btn>
        <v-btn v-if="!!value.mergeConfig" @click="onMergeConfig" small color="success"
               class="my-1 fill-width">Merge Config
        </v-btn>
        <v-btn v-else @click="onMergeConfig" small outlined color="primary" class="my-1 fill-width">Merge
          Config
        </v-btn>
        <v-btn v-if="!!value.boostConfig" @click="onBoostConfig" small color="success"
               class="my-1 fill-width">Boost Config
        </v-btn>
        <v-btn v-else @click="onBoostConfig" small outlined color="primary" class="my-1 fill-width">Boost
          Config
        </v-btn>
        <v-btn v-if="!!value.upgradeConfig" @click="onUpgradeConfig" small color="success"
               class="my-1 fill-width">Upgrade Config
        </v-btn>
        <v-btn v-else @click="onUpgradeConfig" small outlined color="primary" class="my-1 fill-width">Upgrade
          Config
        </v-btn>
        <v-btn v-if="!!value.recycleConfig" @click="onRecycleConfig" small color="success"
               class="my-1 fill-width">Recycle Config
        </v-btn>
        <v-btn v-else @click="onRecycleConfig" small outlined color="primary" class="my-1 fill-width">Recycle Config
        </v-btn>
        <v-btn v-if="!!value.deprecateConfig" @click="onDeprecateConfig" small color="success"
               class="my-1 fill-width">Deprecate Config
        </v-btn>
        <v-btn v-else @click="onDeprecateConfig" small outlined color="primary" class="my-1 fill-width">Deprecate
          Config
        </v-btn>
        <v-btn v-if="!!value.guardConfig" @click="onGuardConfig" small color="success"
               class="my-1 fill-width">Guard Config
        </v-btn>
        <v-btn v-else @click="onGuardConfig" small outlined color="primary" class="my-1 fill-width">Guard
          Config
        </v-btn>
        <v-btn v-if="!!value.offerConfig" @click="onOfferConfig" small color="success"
               class="my-1 fill-width">Offer Config
        </v-btn>
        <v-btn v-else @click="onOfferConfig" small outlined color="primary" class="my-1 fill-width">Offer
          Config
        </v-btn>
        <v-btn v-if="!!value.traderConfig" @click="onTraderConfig" small color="success"
               class="my-1 fill-width">Trader Config
        </v-btn>
        <v-btn v-else @click="onTraderConfig" small outlined color="primary" class="my-1 fill-width">Trader
          Config
        </v-btn>
        <v-btn v-if="!!value.dragonConfig" @click="onDragonConfig" small color="success"
               class="my-1 fill-width">Dragon Config
        </v-btn>
        <v-btn v-else @click="onDragonConfig" small outlined color="primary" class="my-1 fill-width">Dragon
          Config
        </v-btn>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-btn v-if="!!value.attributes" @click="onAttributes" small color="success"
               class="my-1 fill-width">Attributes
        </v-btn>
        <v-btn v-else @click="onAttributes" small outlined color="primary" class="my-1 fill-width">
          Attributes
        </v-btn>
        <v-btn v-if="!!value.infoConfig" @click="onInfoConfig" small color="success"
               class="my-1 fill-width">Info Config
        </v-btn>
        <v-btn v-else @click="onInfoConfig" small outlined color="primary" class="my-1 fill-width">Info
          Config
        </v-btn>
        <v-btn v-if="!!value.touchConfig" @click="onTouchConfig" small color="success"
               class="my-1 fill-width">Touch Config
        </v-btn>
        <v-btn v-else @click="onTouchConfig" small outlined color="primary" class="my-1 fill-width">Touch
          Config
        </v-btn>

        <v-checkbox v-model="value.move" class="mx-1 mt-0" label="Move" hide-details/>
        <v-checkbox v-model="value.swap" class="mx-1 mt-2" label="Swap" hide-details/>
        <v-checkbox v-model="value.archive" class="mx-1 mt-2" label="Archive" hide-details/>
        <v-checkbox v-model="value.delete" class="mx-1 mt-2" label="Delete" hide-details/>
        <v-checkbox v-model="value.explode" class="mx-1 mt-2" label="Explode" hide-details/>
        <v-checkbox v-model="value.autoreward" class="mx-1 mt-2" label="AutoReward" hide-details/>
        <v-checkbox v-model="value.roadThrough" class="mx-1 mt-2" label="Road Through" hide-details/>
        <v-checkbox v-model="value.infoEnabled" class="mx-1 mt-2" label="Info Enabled" hide-details/>
        <v-checkbox v-model="value.bubbleReward" class="mx-1 mt-2" label="Bubble Reward" hide-details/>
      </v-col>
    </v-row>

    <r-search-config ref="r-search-config"/>
    <r-worker-config ref="r-worker-config"/>
    <r-guard-dialog ref="r-guard-dialog"/>
    <r-reward-dialog ref="v-reward-config"/>
    <r-attributes-dialog ref="r-attributes-dialog"/>

    <r-item-info-config ref="r-info-config"/>
    <r-item-boost-config ref="r-boost-config"/>
    <r-item-merge-config ref="r-merge-config"/>
    <r-item-offer-config ref="r-offer-config"/>
    <r-item-trader-config ref="r-trader-config"/>
    <r-item-dragon-config ref="r-dragon-config"/>
    <r-item-upgrade-config ref="r-upgrade-config"/>
    <r-item-recycle-config ref="r-recycle-config"/>
    <r-item-deprecate-config ref="r-deprecate-config"/>
    <r-item-touch-config ref="r-touch-config"/>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {ItemConfig} from "@/modules/redactor/models/item/ItemConfig";

import RRewardDialog from "@/modules/redactor/views/reward/r-reward-dialog.vue";
import RGuardDialog from "@/modules/redactor/views/guard/r-guard-dialog";
import RSearchConfig from "@/modules/redactor/views/search/r-search-config";
import RWorkerConfig from "@/modules/redactor/views/worker/r-worker-config";
import RAttributesDialog from "@/modules/redactor/views/attribute/r-attributes-dialog.vue";
import RItemDeprecateConfig from "@/modules/redactor/views/item/deprecate/r-item-deprecate-config.vue";
import RItemUpgradeConfig from "@/modules/redactor/views/item/upgrade/r-item-upgrade-config.vue";
import RItemRecycleConfig from "@/modules/redactor/views/item/recycle/r-item-recycle-config.vue";
import RItemMergeConfig from "@/modules/redactor/views/item/merge/r-item-merge-config.vue";
import RItemOfferConfig from "@/modules/redactor/views/item/offer/r-item-offer-config.vue";
import RItemTraderConfig from "@/modules/redactor/views/item/trader/r-item-trader-config.vue";
import RItemDragonConfig from "@/modules/redactor/views/item/dragon/r-item-dragon-config.vue";
import RItemBoostConfig from "@/modules/redactor/views/item/boost/r-item-boost-config.vue";
import RItemCollectMode from "@/modules/redactor/views/item/r-item-collect-mode.vue";
import RItemContainerMode from "@/modules/redactor/views/item/r-item-container-mode.vue";
import RItemInfoConfig from "@/modules/redactor/views/item/info/r-item-info-config.vue";
import RItemTouchConfig from "@/modules/redactor/views/item/touch/r-item-touch-config.vue";

export default {
  name: "r-item-config",
  components: {
    RItemTouchConfig,
    RItemInfoConfig,
    RItemContainerMode,
    RItemCollectMode,
    RItemBoostConfig,
    RItemDragonConfig,
    RItemTraderConfig,
    RItemOfferConfig,
    RItemMergeConfig,
    RItemRecycleConfig,
    RItemUpgradeConfig,
    RItemDeprecateConfig,
    RAttributesDialog,
    RRewardDialog,
    RWorkerConfig,
    RSearchConfig,
    RGuardDialog,
  },
  props: {
    model: VueTypes.instanceOf(ItemConfig),
  },
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new ItemConfig();
        this.$emit("update:model", value);
        return value;
      }
    },
    shapeTypes() {
      return [{id: 0, name: '1x1'}, {id: 1, name: '1x2'}, {id: 2, name: '2x2'}, {id: 3, name: '3x3'}, {id: 4, name: '2x1'}];
    }
  },
  methods: {
    onRewardOnMerge() {
      let data = this.value.rewardOnMerge ? this.value.rewardOnMerge.clone() : null;
      this.$refs['v-reward-config'].show(ViewRules.UPDATE, data).then(data => {
        this.value.rewardOnMerge = data;
      }).catch(() => {
      });
    },
    onRewardOnCreate() {
      let data = this.value.rewardOnCreate ? this.value.rewardOnCreate.clone() : null;
      this.$refs['v-reward-config'].show(ViewRules.UPDATE, data).then(data => {
        this.value.rewardOnCreate = data;
      }).catch(() => {
      });
    },
    onRewardOnRemove() {
      let data = this.value.rewardOnRemove ? this.value.rewardOnRemove.clone() : null;
      this.$refs['v-reward-config'].show(ViewRules.UPDATE, data).then(data => {
        this.value.rewardOnRemove = data;
      }).catch(() => {
      });
    },
    onRewardOnDelete() {
      let data = this.value.rewardOnDelete ? this.value.rewardOnDelete.clone() : null;
      this.$refs['v-reward-config'].show(ViewRules.UPDATE, data).then(data => {
        this.value.rewardOnDelete = data;
      }).catch(() => {
      });
    },
    onRewardOnLevelUp() {
      let data = this.value.rewardOnLevelUp ? this.value.rewardOnLevelUp.clone() : null;
      this.$refs['v-reward-config'].show(ViewRules.UPDATE, data).then(data => {
        this.value.rewardOnLevelUp = data;
      }).catch(() => {
      });
    },

    onSearchConfig() {
      let data = this.value.searchConfig ? this.value.searchConfig.clone() : null;
      this.$refs['r-search-config'].show(ViewRules.UPDATE, data).then(data => {
        this.value.searchConfig = data;
      }).catch(() => {
      });
    },
    onInfoConfig() {
      let data = this.value.infoConfig ? this.value.infoConfig.clone() : null;
      this.$refs['r-info-config'].show(ViewRules.UPDATE, data).then(data => {
        this.value.infoConfig = data;
      }).catch(() => {
      });
    },
    onBoostConfig() {
      let data = this.value.boostConfig ? this.value.boostConfig.clone() : null;
      this.$refs['r-boost-config'].show(ViewRules.UPDATE, data).then(data => {
        this.value.boostConfig = data;
      }).catch(() => {
      });
    },
    onMergeConfig() {
      let data = this.value.mergeConfig ? this.value.mergeConfig.clone() : null;
      this.$refs['r-merge-config'].show(ViewRules.UPDATE, data).then(data => {
        this.value.mergeConfig = data;
      }).catch(() => {
      });
    },
    onWorkerConfig() {
      let data = this.value.workerConfig ? this.value.workerConfig.clone() : null;
      this.$refs['r-worker-config'].show(ViewRules.UPDATE, data).then(data => {
        this.value.workerConfig = data;
      }).catch(() => {
      });
    },
    onGuardConfig() {
      let data = this.value.guardConfig ? this.value.guardConfig.clone() : null;
      this.$refs['r-guard-dialog'].show(ViewRules.UPDATE, data).then(data => {
        this.value.guardConfig = data;
      }).catch(() => {
      });
    },
    onOfferConfig() {
      let data = this.value.offerConfig ? this.value.offerConfig.clone() : null;
      this.$refs['r-offer-config'].show(ViewRules.UPDATE, data).then(data => {
        this.value.offerConfig = data;
      }).catch(() => {
      });
    },
    onTraderConfig() {
      let data = this.value.traderConfig ? this.value.traderConfig.clone() : null;
      this.$refs['r-trader-config'].show(ViewRules.UPDATE, data).then(data => {
        this.value.traderConfig = data;
      }).catch(() => {
      });
    },
    onDragonConfig() {
      let data = this.value.dragonConfig ? this.value.dragonConfig.clone() : null;
      this.$refs['r-dragon-config'].show(ViewRules.UPDATE, data).then(data => {
        this.value.dragonConfig = data;
      }).catch(() => {
      });
    },
    onUpgradeConfig() {
      let data = this.value.upgradeConfig ? this.value.upgradeConfig.clone() : null;
      this.$refs['r-upgrade-config'].show(ViewRules.UPDATE, data).then(data => {
        this.value.upgradeConfig = data;
      }).catch(() => {
      });
    },
    onRecycleConfig() {
      let data = this.value.recycleConfig ? this.value.recycleConfig.clone() : null;
      this.$refs['r-recycle-config'].show(ViewRules.UPDATE, data).then(data => {
        this.value.recycleConfig = data;
      }).catch(() => {
      });
    },
    onDeprecateConfig() {
      let data = this.value.deprecateConfig ? this.value.deprecateConfig.clone() : null;
      this.$refs['r-deprecate-config'].show(ViewRules.UPDATE, data).then(data => {
        this.value.deprecateConfig = data;
      }).catch(() => {
      });
    },
    onTouchConfig() {
      let data = this.value.touchConfig ? this.value.touchConfig.clone() : null;
      this.$refs['r-touch-config'].show(ViewRules.UPDATE, data).then(data => {
        this.value.touchConfig = data;
      }).catch(() => {
      });
    },
    onAttributes() {
      let data = this.value.attributes ? this.value.attributes.clone() : null;
      this.$refs['r-attributes-dialog'].show(ViewRules.UPDATE, data).then(data => {
        this.value.attributes = data;
      }).catch(() => {
      });
    }
  }
}
</script>

<style lang="css" scoped>
.fill-width {
  width: 100%;
}
</style>